export default __webpack_public_path__ + "static/media/opme.62638c74.png";